module.exports = __webpack_public_path__ + "img/sinBarreras225.a9cd7d79.jpg";